"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellText = exports.CellStatus = exports.CellDashedContainer = exports.CellDashed = exports.Cell = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _colors = require("../../utils/colors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cell = exports.Cell = function Cell(props) {
  var children = props.children,
    className = props.className,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$Container = props.Container,
    Container = _props$Container === void 0 ? function (containerProps) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, containerProps.children);
    } : _props$Container;
  return /*#__PURE__*/_react["default"].createElement("td", {
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(Container, props, children(props)));
};
var CellText = exports.CellText = function CellText(props) {
  var formatedProps = (0, _react.useMemo)(function () {
    var _props$column = props.column,
      column = _props$column === void 0 ? {} : _props$column;
    var align = column.align;
    var className = (0, _classnames["default"])("text-".concat(align || 'left'));
    return _objectSpread(_objectSpread({}, props), {}, {
      className: className
    });
  }, [props]);
  return /*#__PURE__*/_react["default"].createElement(Cell, formatedProps);
};
var CellStatus = exports.CellStatus = function CellStatus(props) {
  var formatedProps = (0, _react.useMemo)(function () {
    var _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      column = props.column,
      _props$statusColor = props.statusColor,
      statusColor = _props$statusColor === void 0 ? null : _props$statusColor;
    var align = column.align;
    var stringValue = typeof value === 'string';
    var textColor = (0, _classnames["default"])(
    // eslint-disable-next-line no-nested-ternary
    stringValue && (0, _colors.getTextColor)(value) ? (0, _colors.getTextColor)(value) : value ? 'success' : 'danger');
    var className = (0, _classnames["default"])("text-".concat(align || 'left'), !statusColor && "text-".concat("".concat(textColor || 'default')));

    // eslint-disable-next-line no-nested-ternary
    var valueToShow = stringValue ? value : value ? 'Activo' : 'Inactivo';
    var style = {
      color: statusColor || ''
    };
    return _objectSpread(_objectSpread({}, props), {}, {
      className: className,
      value: valueToShow,
      style: style
    });
  }, [props]);
  return /*#__PURE__*/_react["default"].createElement(Cell, formatedProps);
};
var CellDashedContainer = exports.CellDashedContainer = function CellDashedContainer(props) {
  var fixedColor = props.fixedColor,
    textClass = props.textClass,
    value = props.value;
  var cls = (0, _classnames["default"])('dash', value.toLowerCase() !== 'normal' && 'dash--error');
  var textClasses = (0, _classnames["default"])('d-flex flex-row align-items-center', textClass);
  var style = fixedColor ? {
    backgroundColor: fixedColor
  } : {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: textClasses
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: cls,
    style: style
  }), value);
};
var CellDashed = exports.CellDashed = function CellDashed(props) {
  var formatedProps = (0, _react.useMemo)(function () {
    var column = props.column;
    var _column$align = column.align,
      align = _column$align === void 0 ? 'left' : _column$align;
    var className = (0, _classnames["default"])("text-".concat(align));
    return _objectSpread(_objectSpread({}, props), {}, {
      className: className
    });
  }, [props]);
  return /*#__PURE__*/_react["default"].createElement(Cell, _extends({}, formatedProps, {
    Container: CellDashedContainer
  }));
};